import React from "react";
import { Star, Quote } from "lucide-react";
import Reveal from "../components/Reveal";
import { useSite } from "../context/SiteContext";

export const ParentReviews = ({ standalone = false }) => {
    const { content } = useSite();
    const r = content.reviews || {};
    const items = r.items || [];
    const title = (r.title || "").split("\n");

    return (
        <section
            id="reviews"
            data-testid="reviews-section"
            className={`relative bg-white ${standalone ? "pt-36 pb-28" : "py-24 lg:py-32"}`}
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 mb-14">
                    <Reveal className="lg:col-span-7">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#14545E]/10 text-[#14545E] text-[11px] tracking-[0.2em] uppercase mb-5">
                            {r.eyebrow}
                        </div>
                        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#0A1F3D] leading-[1.05]">
                            {title.map((line, i) => (
                                <div key={i}>
                                    {i === title.length - 1 ? (
                                        <span className="text-[#14545E]">{line}</span>
                                    ) : (
                                        line
                                    )}
                                </div>
                            ))}
                        </h2>
                    </Reveal>
                </div>

                <div className="grid md:grid-cols-2 gap-5 lg:gap-6">
                    {items.map((it, i) => (
                        <Reveal key={it.id || i} delay={i * 0.08}>
                            <article
                                data-testid={`review-${i}`}
                                className="bg-[#FAFAFA] border border-neutral-200 rounded-2xl p-7 lg:p-8 h-full flex flex-col gap-5 hover:border-[#14545E] hover:shadow-lg hover:shadow-[#14545E]/5 transition-all"
                            >
                                <div className="flex items-start justify-between">
                                    <Quote size={28} className="text-[#14545E]/30" />
                                    <div className="flex gap-0.5">
                                        {Array.from({ length: it.rating || 5 }).map(
                                            (_, n) => (
                                                <Star
                                                    key={n}
                                                    size={14}
                                                    className="fill-[#14545E] text-[#14545E]"
                                                />
                                            )
                                        )}
                                    </div>
                                </div>
                                <p className="text-[#0A1F3D] leading-relaxed text-base flex-1">
                                    “{it.text}”
                                </p>
                                <div className="pt-4 border-t border-neutral-200">
                                    <div className="font-serif-display text-lg text-[#0A1F3D]">
                                        {it.name}
                                    </div>
                                    <div className="text-xs text-neutral-500 mt-0.5">
                                        {it.relation}
                                    </div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ParentReviews;
